export const SHOW_HIDE = 'show_hide_menu';
